import { computed } from 'vue';
import { useMainStore } from '../stores/mainStore';

/**
 * Shared state for Contact Form groups mode (MP-2260).
 * Set by fetchOrganizations after probing the public groups API or receiving 403.
 */
export const useContactFormGroupsMode = () => {
  const customGroupsEnabled = useState<boolean | null>('contactForm.customGroupsEnabled', () => null);
  const mainStore = useMainStore();

  const useCustomGroups = computed(() => {
    if (customGroupsEnabled.value !== null) {
      return Boolean(customGroupsEnabled.value);
    }

    return !!mainStore.featureFlags?.task_management_custom_organizations;
  });

  const setCustomGroupsEnabled = (value: boolean) => {
    customGroupsEnabled.value = value;
  };

  return {
    customGroupsEnabled,
    useCustomGroups,
    setCustomGroupsEnabled,
  };
};
